/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import { makeStyles } from 'tss-react/mui';

import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import { Field, getIn } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const RenderMultiSelect = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  children,
  dataSource,
  ...others
}) => {
  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  return (
    <FormControl
      variant="standard"
      error={touch && error != null}
      className={classes.formControl}
      {...others}
    >
      <InputLabel shrink>{label}</InputLabel>
      {dataSource && (
        <Select
          variant="standard"
          multiple
          value={field.value || []}
          onChange={(event) => {
            setFieldValue(field.name, event.target.value);
          }}
          renderValue={(selected) => {
            return dataSource
              .filter((o) => selected.includes(o.id))
              .map((o) => o.name)
              .join(', ');
          }}
        >
          {dataSource.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={field.value && field.value.includes(option.id)} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
      )}
      {touch && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export const FormMultiSelect = ({ name, dataSource, ...others }) => (
  <Field name={name} component={RenderMultiSelect} dataSource={dataSource} {...others} />
);
